export default {
  form: {
    should_save_payment_info: {
      label: 'Guardar dados de pagamento para checkout mais rápido',
    },
  },
};
